/* eslint-disable indent */
import Vue from 'vue';

Vue.component('AgGridVue', async (resolve, reject) => {
  try {
    // 因为ag-grid-vue依赖ag-grid-enterprise所以要串联加载，不能并行
    const { LicenseManager } = await window.importByCDN('ag-grid-enterprise');
    const { AgGridVue } = await window.importByCDN('ag-grid-vue');
                                                
                       
                                                          
                                                                 
       
             
    LicenseManager.setLicenseKey('CompanyName=Leiga,LicensedGroup=Leiga,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=2,AssetReference=AG-031054,SupportServicesEnd=29_July_2023_[v2]_MTY5MDU4NTIwMDAwMA==cd55d9d6d5aafcaf1a31fd43f416b2ff');

    resolve(AgGridVue);
  } catch (e) {
    reject(e);
  }
});
